import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const main = css`
  max-width: 40rem;
`;

export const descriptionContainer = css`
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
`;

export const description = css`
  max-width: 25rem;
  text-align: center;
`;

export const actions = css`
  margin-top: 1.5rem;
  display: flex;
  justify-content: flex-end;

  @media (max-width: ${dimensions.phoneLarge}) {
    flex-direction: column;
  }
`;

export const button = css`
  &:first-of-type {
    margin-right: 0.5rem;
  }

  @media (max-width: ${dimensions.phoneLarge}) {
    width: 100%;
    &:first-of-type {
      margin-bottom: 0.5rem;
      margin-right: 0;
    }
  }
`;
